/**
 * Coordinator session status constants.
 * When session status is in this list, polling should stop (terminal/error states).
 * Keep in sync with COORDINATOR_CALL_STATUS_CONFIG in coordinatorCallStatusConfig.ts.
 */
export const COORDINATOR_POLL_STOP_STATUSES: readonly string[] = [
  'completed',
  'failed',
  'callback_scheduled',
  'voicemail',
  'requested_email',
  'no_answer',
  'ignored',
  'unknown',
  'call_failed',
  'call_disconnected',
  'wrong_number',
  'retry_scheduled',
];

/**
 * For ad-hoc "Reschedule with AI" visibility: only hide when an ad-hoc session
 * is in one of these statuses (call is actively queued, ringing, or in progress).
 * Do NOT block for "scheduled" (future call) or terminal statuses.
 */
export const COORDINATOR_ADHOC_BLOCKING_STATUSES: readonly string[] = [
  'queued',
  'initialising',
  'ringing',
  'in_progress',
];
